export const getSortName = (name) => {
  if (name && name.length > 0) {
    return (
      name.split(" ")[0]?.[0]?.toUpperCase() +
      name.split(" ")[1]?.[0]?.toUpperCase()
    );
  }
  return "NA";
};
